/* Homepage link corrections. v2.

   templates/index.liquid is 236KB, past what the Admin API will replace as
   text, so links in it that need to change are corrected here at run time.
   Same route as rockkt-factfix-v2.js, which does the same for product facts.

   v2 removes two links from the pricing section, on Glen's instruction:

   1. "See the ROI guarantee ->" pointed at /products/roi, which is not a page
      or a product any more. v1 sent it to /pages/pricing instead; that page
      has no ROI-guarantee section to land on, so the link is gone. The ROI
      card itself stays: its wording IS the guarantee.

   2. "See full pricing ->" is gone. The pricing page is one click away in the
      header and in the six-button band below, and the link was reported as
      not working. Nothing else on the homepage depended on it.

   Both are removed from the DOM rather than hidden, so nothing reads them. */
(function () {
  function fix() {
    var sec = document.getElementById('pricing');
    if (!sec) return;
    sec.querySelectorAll('a.roi-link, a[href*="/products/roi"], a.perf-link').forEach(function (a) {
      if (a.parentNode) a.parentNode.removeChild(a);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix);
  else fix();
})();
